


















export default {
	name: 'ButtonTertiary',

	props: {
		text: {
			required: false,
			type: String,
		},
		icon: {
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
			default: false,
		},
		small: {
			default: false,
			required: false,
			type: Boolean,
		},
		name: {
			required: false,
			type: String,
		},
	},
};
